import type {NextPage} from "next";
  import Layout from "@/components/Layout";
  import RadarMap from "@/components/RadarMap";
  
  const Page: NextPage<any> = () => {    
  
    return (
      <Layout>
        <link
          rel="stylesheet"
          href="https://unpkg.com/leaflet@1.6.0/dist/leaflet.css"
          integrity="sha512-xwE/Az9zrjBIphAcBb3F6JVqxf46+CDLwfLMHloNu6KEQCAWi6HcDUbeOfBIptF7tcCzusKFjFw2yuvEpDL9wQ=="
          crossOrigin=""
        />
        <RadarMap/>
      </Layout>
    );
  };
  
  export default Page;
  